import { VisitActivityResponseDto } from 'woofwoof-api';
import { axiosBackendClient } from './client';

/**
 * Owner-scoped visit read endpoints.
 *
 * Mirrors a subset of the organization-scoped modal data so the owner-facing
 * VisitModalDetailsTabs can render the same read-only tabs (Przebieg wizyty,
 * Lekarstwa, Zabiegi, Dokumenty). Ownership is validated server-side via
 * req.user.id.
 *
 * NB: inlined here (rather than through the generated woofwoof-api client)
 * because this endpoint was added after the last API client regen.
 */
export const visitOwnerApi = {
  getActivity: (visitId: string) =>
    axiosBackendClient.get<VisitActivityResponseDto[]>(
      `/api/visit/${visitId}/owner-activity`,
    ),
};
